<template>
  <div id="mySidenav" class="sidenav">

    <button class="close-btn" id="close-btn" @click="$emit('callMenu')">
      <i class="bi bi-x" ></i>
    </button>
    <router-link to="">  </router-link>
    <router-link to="/search/stacker"> Search </router-link>
    <router-link to="/gallery"> Gallery </router-link>
    <router-link to="/VirtualTour"> Virtual Tour </router-link>
    <router-link to="/specs"> Specifications </router-link>
    <!-- <router-link to="/options"> Options </router-link> -->
    <router-link to="/location"> Location </router-link>
    <router-link to="/favourites"> Favourites </router-link>
    <router-link to="/cmslogin"> CMS </router-link>
    <!-- <router-link to="/galleryslideshow">
            Gallery View 2
        </router-link> -->
  </div>
</template>

<script>
export default {
  name: "Sidemenu",
  emits: ['callMenu']
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
* {
  font-family: "rustica-regular";
}

.close-btn {
  border: none;
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  i {
    color: #381b31;
    font-size: 35px;
  }
}

.sidenav {
  height: calc(100vh - 70px);
  width: 0;
  position: absolute;
  z-index: 9999;
  top: 0px;
  right: 0;
  bottom: 0;
  background-color: rgba(100, 167, 166, 0.9);
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  margin-top: 0;
  margin-bottom: 70px;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 20px;
  color: #fff;
  display: block;
  transition: 0.3s;
  text-transform: uppercase;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }

  .sidenav a {
    font-size: 18px;
  }
}

.logo {
  position: fixed;
  bottom: 90px;
  width: 250px;
  text-align: center;
  display: none;
  img {
    width: 120px;
  }
}

@media screen and (max-width: 767px) and (orientation: portrait) {
  .logo {
    display: block;
  }

  .sidenav {
    padding-top: 20px;
    margin: 70px 0 0;
    height: calc(100vh - 140px);
  }

  .close-btn {
    top: 10px;
    right: 10px;
  }

}

@media screen and (max-width: 1024px)  {
  .sidenav {
    padding-top: 20px;
    margin: 70px 0 0;
    height: calc(100vh - 140px);
  }

}
</style>
